const config = {
  razorpayKey: "rzp_live_skmGlZBn13v7U6",
  apiBaseUrl:process.env.REACT_APP_BASE_URL || "https://console.careertest.online/api",
  gaTrackingId: "G-FCGQYEHQ02",
  typeformToken: "",
};

export default config;
